module.exports = __webpack_public_path__ + "img/nav-46.1adeef76.png";